const release = document.querySelector('body')?.dataset?.release

if (typeof Sentry !== "undefined") {
  const host = window.location.host;
  let environment = "production";
  if (host.includes("bizzw.com")) environment = "staging";
  if (!host.includes(".local")) {
    Sentry.init({
      dsn: "https://1af641536b94439db58fe42b6935deb9@o410132.ingest.sentry.io/4504592948658176",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: environment === "production" ? 0.1 : 1,
      environment,
      release
    });
  }
}

function logError(error) {
  console.error(error);
  if (typeof Sentry !== "undefined"){
    Sentry.captureException(error)
  }
}